import type { Shape, Vec2 } from '../geom';
import type { NodeId } from '../model';
import type { SnapKind } from './kinds';

export interface SnapCandidate {
  readonly kind: SnapKind;
  readonly point: Vec2;
  readonly sourceIds: readonly NodeId[];
}

export interface SnapResult extends SnapCandidate {
  readonly distancePx: number;
}

export interface SnapSettings {
  /** The one kind that snaps, chosen by its letter; nothing snaps while it is null. */
  readonly kind: SnapKind | null;
  readonly tolerancePx: number;
  readonly gridSize: number;
  readonly ortho: boolean;
  readonly angleStep: number;
}

export const DEFAULT_SNAP_SETTINGS: SnapSettings = {
  kind: null,
  tolerancePx: 12,
  gridSize: 10,
  ortho: false,
  angleStep: 45,
};

/**
 * Geometry a tool adds to snapping while it places a point, such as the line an entity is
 * being extended along. It snaps like an entity, as `sourceId`, but is not in the drawing.
 */
export interface Construction {
  readonly sourceId: NodeId;
  readonly shape: Shape;
}
